import { ProjectCarousel } from "./ProjectCarousel";
import { ProjectInfo } from "./ProjectInfo";
import projectData from "./data/projectData.json";
import { useEffect, useState } from "react";




export function Projects() {
    const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth >= 1024);

    useEffect(() => {
        const handleResize = () => {
            setIsLargeScreen(window.innerWidth >= 1024);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <div className="flex flex-col justify-center bg-gray-100 scroll-mt-14 space-y-6 px-6 py-10" id="projects">
            <h1 className="text-3xl font-bold text-red-600 w-11/12 lg:w-[954px] self-center font-dmsans">My Projects</h1>
            { projectData.map(project => 
                project.key % 2 == 0 || !isLargeScreen ?
                    <div className="flex flex-col lg:flex-row lg:self-center pb-14 lg:w-[954px] lg:space-x-6">
                        <ProjectInfo github={project.github} link={project.link} name={project.name} description={project.description} stack={project.stack}/> 
                        <ProjectCarousel images={project.images}/>
                    </div> :
                    <div className="flex flex-col lg:flex-row lg:self-center pb-14 lg:w-[954px] lg:space-x-6">
                        <ProjectCarousel images={project.images} />
                        <ProjectInfo github={project.github} link={project.link} name={project.name} description={project.description} stack={project.stack}/> 
                    </div>
            )}
        </div>
    )
}